import type { FilterField, SelectFilterField } from '@/components/common/AdvancedFilter';
import { toFilterOptions } from '@/utils/filters';
import type { PromoItemType } from '../types/promotion.types';

export function getPromoItemTypeFilterField(
  itemTypes: PromoItemType[] | undefined,
): SelectFilterField {
  return {
    key: 'itemTypeId',
    label: 'Item Type',
    type: 'select',
    placeholder: 'All Item Types',
    options: toFilterOptions(itemTypes),
    searchable: true,
  };
}

export function getItemCodeFilterField(): FilterField {
  return { key: 'itemCode', label: 'Item Code', type: 'text', placeholder: 'UMB-01' };
}
